module.exports = __webpack_public_path__ + "img/peach.be5030ca.webp";